const removeNonPrintableASCII = (str: string) => str.replace(/[^\x20-\x7E]/g, '');

export default removeNonPrintableASCII;
